export default __webpack_public_path__ + "static/media/Aerial1.b27cdad7.jpg";